import moment from 'moment';
import React from 'react';

const CommentElement = (props) => {
  return (
    <div className='dynamic-report-item'>
      <div className='label'>
        {props.prompt}
      </div>
      <div className='field'>
        {moment(props.datetime).format('MMM D, YYYY')}
      </div>
    </div>
  );
};

export default CommentElement;
